import Vue from "vue";
import { getRawSsin } from "@/@shared/propass/store/nissStore";
import { i18n } from "@/@core";
import { Traductions } from "@/@shared/propass/services/interfaces/base/CommonTypes";

export default Vue.extend({
  methods: {
    dateIsValid(date: any) {
      return !Number.isNaN(new Date(date).getTime());
    },
    formatSsin(x: string) {
      if (x) {
        const ssin = x.replace(/\D/g, "");
        const char: any = { 0: "", 5: "", 6: "-", 9: "-" };
        x = "";
        for (let i = 0; i < ssin.length; i++) {
          x += (char[i] || "") + ssin[i];
        }
        return x;
      }
      return "";
    },
    getCleanedSsin(x: string) {
      return x ? x.replace(/\D/g, "") : x;
    },
    getFormattedSsin(x: string) {
      return x ? `${x.substr(0, 2)}${x.substr(2, 2)}${x.substr(4, 2)}-${x.substr(6, 3)}-${x.substr(9, 2)}` : x;
    },
    getTranslation(x: Traductions) {
      return x.find(entry => entry.language?.toLowerCase() == i18n.locale?.toLowerCase())?.value || x[0]?.value || "";
    },
    parseDate(value: string): string {
      // const dateWihoutTime = value.split('T')
      const date = new Date(value);
      return [
        date.getDate().toLocaleString("fr-FR", { minimumIntegerDigits: 2 }),
        (date.getMonth() + 1).toLocaleString("fr-FR", { minimumIntegerDigits: 2 }),
        date.getFullYear(),
      ].join("/");
    },
    removeSpecialChars(value: any): any {
      return value
        ? value
            .replace(/(?!\w|\s)./g, "")
            .replace(/\s+/g, " ")
            .replace(/^(\s*)([\W\w]*)(\b\s*$)/g, "$2")
        : value;
    },
  },
});
